import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import WaterDropGrid from './components/WaterDropAnimation';
import IntroDetails from './components/intro';  
import Navbar from './components/navbar';
import AnimatedProfile from './components/AnimatedProfile';
import TechStack from './components/TechStack';
import Projects from './components/Projects';
import TechBlog from './components/techBlog';
import Timeline from './components/Timeline';
import Footer from './components/Footer';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
    <>
    
    <Navbar/>
    <div id="introSection" className='flex flex-col md:flex-row items-center md:h-screen w-[screen] mt-[20px] m-0 justify-center md:max-[1200px]:scale-75 '>
            <div className='absolute md:relative overflow-hidden md:overflow-visible'>
                <WaterDropGrid/>
            </div>
            
            <div className="md:relative md:right-[80px] md:bottom-12 md:pl-3 pb-5 md:pr-1 mt-5">
                {/* <div className='z-[-1] absolute top-0 bottom-0 right-0 left-0 border-[2px] border-gray-500'></div> */}
                <IntroDetails/>       
            </div>

            <div className='md:relative right-[2vw] top-[1vh] z-[1]'><AnimatedProfile/></div>
            
            
            
    </div>
    <TechStack/>
    <Timeline/>
    <Projects/>
    <TechBlog/>
    <Footer/>
    


    </>

);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
